import type { Validator } from './types';

export function makeMaxValueValidator(maxValue: number, message: string): Validator<string> {
    return (value?: string) => (!value || Number(value) <= maxValue ? undefined : message);
}
